module.exports = __webpack_public_path__ + "static/media/GG.c066fc16.svg";